// Friendly text + classification for backend Xero sync error messages.
// The backend builds raw strings like:
//   "Sync failed — txn:0/0 (Rate limit exceeded when calling Xero API. Please try again later.) | bills:0/0 (...) | self:0/0"
// We surface a short, human-friendly summary instead of the raw phase string.

export interface XeroSyncErrorInfo {
  /** Short, user-facing message safe to render in a chip/caption. */
  display: string;
  /** True when the failure is a Xero 429 rate-limit (recoverable by waiting). */
  isRateLimit: boolean;
}

export function classifyXeroSyncError(raw: string | null | undefined): XeroSyncErrorInfo {
  const text = (raw ?? '').toString();

  if (/rate limit/i.test(text) || /\b429\b/.test(text)) {
    return {
      display: 'Xero API rate limit — try again in a minute',
      isRateLimit: true,
    };
  }

  // Fallback: strip the noisy "txn:0/0 (...)" phase blob if present.
  const stripped = text.replace(/^Sync failed\s*—\s*/i, '').trim();
  return {
    display: stripped || 'Sync failed',
    isRateLimit: false,
  };
}
